import { MagentoCountryCodeEnum } from 'lib/types'

export const AUTH_TOKEN_REFRESH_WINDOW_SECONDS = 60 * 5
export const DEFAULT_LOCALE = 'en'
export const DEFAULT_COUNTRY_CODE = 'US'
export const DEFAULT_ERROR_KEY = 'app.whoops'
export const DEFAULT_SUCCESS_KEY = 'app.success'
export const TEXT_PLACEHOLDER = '...'
export const DEFAULT_STORE_ID = 1
export const DEFAULT_CURRENCY_CODE = 'USD'
export const PLUS = '+'
export const DASH = '-'
export const EMPTY_STRING = ''
export const BLANK_SPACE = ' '
export const COMMA = ','
export const QUESTION_MARK = '?'
export const SLASH = '/'
export const LINE_FEED = '\n'
export const PRODUCT_IMAGE_URL = `${process.env.REACT_APP_MAGENTO_URI}/media/catalog/product`
export const CHECKOUT_SUBMIT_DELAY = 500
export const ZERO = 0
export const MAX_PAGE_SIZE = 21
export const LIVBRITE_DEFAULT_STORE_VIEW = 'livbrite_default_storeview'

export const HTTP_STATUS = {
  OK: 200,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  INTERNAL_SERVER_ERROR: 500
}

export const ORDER = {
  ASC: 'asc',
  DESC: 'desc'
}

export const ACCOUNT_MANAGEMENT = {
  EMAIL_RESET: 'email_reset'
}

export const PAYMENT_METHOD = {
  AFFIRM: 'affirm_gateway',
  AUTHNET: 'authorizenet_acceptjs',
  AUTHNETCC: 'anet_creditcard',
  BRAINTREE_PAYPAL: 'braintree_paypal',
  BRAINTREE: 'braintree',
  CHECK_MONEY_ORDER: 'checkmo',
  CYBERSOURCE: 'chcybersource',
  KLARNA_PAY_LATER: 'klarna_pay_later',
  KLARNA_PAY_NOW: 'klarna_pay_now',
  KLARNA_PAY_OVER_TIME: 'klarna_pay_over_time',
  KLARNA_SLICE_IT: 'klarna_slice_it',
  MERCHANTE: 'mes_gateway',
  COMMERCE_HUB: 'commerce_hub',
  COMMERCE_HUB_VAULT: 'commerce_hub_vault',
  PAYEEZY: 'payeezy',
  PAYEEZY_VAULT: 'payeezy_cc_vault',
  PAYFLOW_PRO_CC_VAULT: 'payflowpro_cc_vault',
  PAYFLOW_PRO: 'payflowpro',
  PAYPAL_EXPRESS: 'paypal_express',
  PURCHASE_ORDER: 'purchaseorder',
  FREE: 'free'
}

export const PAYMENT_ERROR = {
  TRANSACTION_DECLINED: 'Transaction has been declined. Please try again later.'
}

export const ERROR = {
  CUSTOMER_EXISTS: 'A customer with the same email address already exists in an associated website.'
}

export const PRODUCT_VISIBILITY = {
  NOT_VISIBLE_INDIVIDUALLY: 1,
  CATALOG: 2,
  SEARCH: 3,
  CATALOG_SEARCH: 4
}

export const PRODUCT_TYPENAME = {
  CONFIGURABLE: 'ConfigurableProduct',
  GROUPED: 'GroupedProduct',
  SIMPLE: 'SimpleProduct',
  GIFT_CARD: 'GiftCardProduct',
  VIRTUAL: 'VirtualProduct'
}

export const ATTRIBUTE_TYPE = {
  SELECT: 'select',
  MULTISELECT: 'multiselect',
  BOOLEAN: 'boolean',
  TEXTAREA: 'textarea'
}

export const PRODUCT_LINKS = {
  LINK_TYPE: 'link_type',
  LINK_TYPE_RELATED: 'related',
  LINKED_PRODUCT_SKU: 'linked_product_sku'
}

export const CATEGORY = {
  ID: 'id',
  CHILDREN: 'children',
  FIRST_LEVEL: 2,
  PARENT_ID: 'parent_id',
  LEVEL: 'level',
  IS_ACTIVE: 'is_active',
  INCLUDE_IN_MENU: 'include_in_menu',
  URL_PATH: 'url_path',
  URL_KEY: 'url_key',
  NAME: 'name',
  IMAGE: 'image',
  THUMBNAIL: 'thumbnail',
  IMAGE_TEXT: 'image_text_hover',
  DESCRIPTION: 'description',
  POSITION: 'position'
}

export const CATALOG_FILTER = {
  PRICE: 'price',
  CATEGORY: process.env.REACT_APP_LAYERED_NAV_CATEGORY_LEGACY ? 'cat' : 'category_id'
}

export const CATALOG_SORT = {
  SORT_BY: 's',
  ASC: 'ASC',
  DESC: 'DESC',
  DEFAULT_SORT: 'position',
  DEFAULT_SORT_SEARCH: 'relevance'
}

export const CATALOG_PAGE = {
  PAGE: 'p',
  PAGE_SIZE: 'ps'
}

export const NOT_FILTERS = [
  CATALOG_SORT.SORT_BY,
  CATALOG_PAGE.PAGE,
  CATALOG_PAGE.PAGE_SIZE
]

export const VARIANT = {
  STOCK_STATUS: 'stock_status',
  OUT_OF_STOCK: 'OUT_OF_STOCK',
  IN_STOCK: 'IN_STOCK'
}

export const RESOLVER = {
  CATEGORY: 'CATEGORY',
  CMS_PAGE: 'CMS_PAGE',
  PRODUCT: 'PRODUCT'
}

export const ENVIRONMENTS = {
  PRODUCTION: 'production'
}

export const POSTAL_CODE_REGEXP: Record<string, RegExp> = {
  [MagentoCountryCodeEnum.US]: /^\d{5}(?:[-\s]\d{4})?$/,
  [MagentoCountryCodeEnum.CA]: /^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z] [0-9][ABCEGHJ-NPRSTV-Z][0-9]$/
}

export const DEFAULT_PATH = {
  login: '/customer/account/login',
  confirmAccount: '/customer/account/confirmation',
  resetPassword: '/customer/account/resetpassword',
  createAccount: '/customer/account/create',
  forgotPassword: '/customer/account/forgotpassword',
  cart: '/cart',
  checkout: '/checkout',
  customer: '/customer',
  search: '/search/:query',
  paypalExpress: '/paypal-express'
}
